import React from 'react';

import { FeatureFlagged, FeatureGatedVariant } from '../../feature-gates/feature-flagged';
import { FeatureGates } from '../../feature-gates/feature-gates';
import { UiMessageBanner } from '../../ui/ui-message-banner';
import Message from '../legacy-message';

import { HELPSCOUT_ARTICLE_KEYS } from '../../util/helpscout-article-keys';
import { HelpScout } from '../../util/helpscout-beacon';

interface Props {
  message: string;
  multipleLanguagePreference?: boolean;
}

export const LanguagePreferenceBanner = ({ message, multipleLanguagePreference }: Props) => {
  const handleArticleClick = () => {
    HelpScout.beacon.openArticle(HELPSCOUT_ARTICLE_KEYS.SENDING_IN_ENGLISH_SPANISH);
  };

  return (
    <>
      <FeatureFlagged
        flagName={FeatureGates.INTEGRATED_MESSAGING}
        variant={FeatureGatedVariant.HIDE_ON_FLAG}
      >
        <Message canBeDismissed={false} className="u-margin-bottom typo-label">
          <div className="typo-body">
            {message}
            <span role="presentation" className="typo-link" onClick={handleArticleClick}>
              {' '}
              Learn about language preferences.
            </span>
          </div>
        </Message>
      </FeatureFlagged>
      <FeatureFlagged
        flagName={FeatureGates.INTEGRATED_MESSAGING}
        variant={FeatureGatedVariant.SHOW_ON_FLAG}
      >
        <UiMessageBanner className="u-margin-y u-borderRadius-10" variant="attention">
          <div className="typo-body">
            <div className="typo-bold u-margin-bottom">
              {multipleLanguagePreference && 'Multiple'} Language Preference
            </div>
            {message}
            <span role="presentation" className="typo-link" onClick={handleArticleClick}>
              {' '}
              Learn about language preferences.
            </span>
          </div>
        </UiMessageBanner>
      </FeatureFlagged>
    </>
  );
};
